import { SelectInputField } from 'components/Form/SelectInputField';
import { useI18n } from 'i18n/hooks/useI18n';

import { ORG_SIZES_EMPLOYEES, ORG_SIZES_MEMBERS } from './orgSizes';

type Props = {
  name: string;
  label: string;
  members?: boolean;
};

export function OrgSizeSelectField({ name, label, members }: Props) {
  const { i18n } = useI18n();

  return (
    <SelectInputField
      label={label}
      description={`(${i18n('Not visible to public')})`}
      name={name}
      options={members ? ORG_SIZES_MEMBERS(i18n) : ORG_SIZES_EMPLOYEES(i18n)}
    />
  );
}
